// src/components/CategoryCards.js
import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { getHomepageCategoryCards } from "../services/homepage.api";

function CategoryCards() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);

  const TEXT = {
    EN: { explore: "EXPLORE" },
    AR: { explore: "استكشف" },
  };

  useEffect(() => {
    getHomepageCategoryCards()
      .then(setCards)
      .catch(() => {});
  }, []);

  const handleClick = (sectionKey) => {
  if (["new-in", "sale", "bestsellers"].includes(sectionKey)) {
    navigate(`/products/${sectionKey}`);
  } else {
    navigate(`/products/category/${sectionKey}`);
  }
};


  return (
    <div className="w-full grid grid-cols-2 gap-3 px-0 mt-20 mb-0">
      {cards.map((card, i) => (
        <button
          key={card.id}
          onClick={() => handleClick(card.key)}
          className="
            relative overflow-hidden group
            bg-black
            transition-all duration-300
            hover:shadow-[0_0_28px_rgba(46,150,42,0.55)]
            hover:-translate-y-1
            card-3d
            animate-fadeIn
            rounded-none
          "
          style={{ animationDelay: `${i * 0.2}s` }}
        >
          {/* IMAGE */}
          <div className="overflow-hidden h-56 md:h-80 lg:h-[380px]">
            {/* MOBILE */}
            <img
              src={card.mobile_image}
              alt={lang === "EN" ? card.title_en : card.title_ar}
              className="
                w-full h-full object-cover
                transition-transform duration-[900ms]
                group-hover:scale-110
                parallax-image
                md:hidden
              "
            />

            {/* DESKTOP */}
            <img
              src={card.desktop_image}
              alt={lang === "EN" ? card.title_en : card.title_ar}
              className="
                hidden md:block
                w-full h-full object-cover
                transition-transform duration-[900ms]
                group-hover:scale-110
                parallax-image
              "
            />
          </div>

          {/* DARK OVERLAY */}
          <div
            className="
              absolute inset-0
              bg-black/40
              opacity-0 group-hover:opacity-100
              transition-opacity duration-300
            "
          />

          {/* SHINE SWEEP */}
          <div
            className="
              absolute inset-0 pointer-events-none
              opacity-0 group-hover:opacity-40
              shine-effect
            "
          />

          {/* LIONS CROSSHAIR */}
          <div
            className="
              absolute inset-0 pointer-events-none
              flex items-center justify-center
              opacity-0 group-hover:opacity-100
              transition-all duration-300
            "
          >
            <div className="crosshair"></div>
          </div>

          {/* TEXT */}
          <div
            className="
              absolute bottom-4 left-1/2 -translate-x-1/2
              text-center
              transition-all duration-300
              group-hover:bottom-6
            "
          >
            <p className="font-semibold text-white drop-shadow-md text-sm md:text-lg lg:text-xl tracking-wide">
              {lang === "EN" ? card.title_en : card.title_ar}
            </p>

            <span className="underline text-[#2E5A2A] drop-shadow-md text-[10px] md:text-sm lg:text-base">
              {lang === "EN" ? TEXT.EN.explore : TEXT.AR.explore}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
}

export default CategoryCards;
